var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": _vm.isMobile ? '90vw' : '500px'
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_vm._v("提现权限")]), _c('div', {
    staticClass: "taskbox"
  }, [_c('div', [_vm._v("设置用户当前资产的提现权限")]), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("用户ID")]), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.user_id,
      expression: "formData.user_id"
    }],
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.formData.user_id
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "user_id", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("提现权限")]), _c('div', {
    staticClass: "input-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.withdrawfund,
      expression: "formData.withdrawfund"
    }],
    attrs: {
      "type": "radio",
      "id": "yes",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.formData.withdrawfund, "1")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.formData, "withdrawfund", "1");
      }
    }
  }), _vm._v("正常状态")]), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.withdrawfund,
      expression: "formData.withdrawfund"
    }],
    attrs: {
      "type": "radio",
      "id": "no",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.formData.withdrawfund, "0")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.formData, "withdrawfund", "0");
      }
    }
  }), _vm._v("不允许")])])])])]), _c('div', {
    staticClass: "btn",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.$lang("Submit")))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };